import { detectRegion, type Region } from "@/lib/regionDetection";
import { useEffect, useState } from "react";

// Amplitude imports removed

export const useRegion = () => {
  const [region, setRegion] = useState<Region>(() => {
    if (typeof window === "undefined") return "LATAM";
    
    // Check localStorage first (for manual region switching)
    const storedRegion = localStorage.getItem("user_region") as Region | null;
    if (storedRegion && ["US", "SPAIN", "LATAM", "OTHER"].includes(storedRegion)) {
      return storedRegion;
    }
    
    // Otherwise, detect from browser
    return detectRegion();
  });

  useEffect(() => {
    // Store in localStorage for consistency
    localStorage.setItem("user_region", region);

    // Amplitude region tracking removed
  }, [region]);

  return { region, setRegion };
};
